var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30.5,
    stroke: "#0AD2C7",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6387 11.2942C33.7316 9.23703 35.9403 7.99779 38.1398 8.96992C38.1398 8.96992 41.1102 10.0136 40.8876 13.6639C40.665 17.3143 36.1737 22.4279 32.6387 24.4035",
    fill: "#D81C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6387 11.2942C33.7316 9.23703 35.9403 7.99779 38.1398 8.96992C38.1398 8.96992 41.1102 10.0136 40.8876 13.6639C40.665 17.3143 36.1737 22.4279 32.6387 24.4035",
    stroke: "#D81C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6363 11.2942C31.4937 9.23703 29.1846 7.99779 26.8851 8.96992C26.8851 8.96992 23.7798 10.0136 24.0125 13.6639C24.2451 17.3143 28.9406 22.4279 32.6363 24.4035",
    fill: "#D81C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6363 11.2942C31.4937 9.23703 29.1846 7.99779 26.8851 8.96992C26.8851 8.96992 23.7798 10.0136 24.0125 13.6639C24.2451 17.3143 28.9406 22.4279 32.6363 24.4035",
    stroke: "#D81C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7427 56V49.6016H25.8345C26.5288 49.6016 27.0503 49.7451 27.3989 50.0322C27.7505 50.3193 27.9263 50.7441 27.9263 51.3066C27.9263 51.6055 27.8413 51.8706 27.6714 52.1021C27.5015 52.3306 27.27 52.5078 26.9771 52.6338C27.3228 52.7305 27.5952 52.915 27.7944 53.1875C27.9966 53.457 28.0977 53.7793 28.0977 54.1543C28.0977 54.7285 27.9116 55.1797 27.5396 55.5078C27.1675 55.8359 26.6416 56 25.9619 56H23.7427ZM24.5864 53.0073V55.3101H25.9795C26.3721 55.3101 26.6812 55.209 26.9067 55.0068C27.1353 54.8018 27.2495 54.5205 27.2495 54.1631C27.2495 53.3926 26.8306 53.0073 25.9927 53.0073H24.5864ZM24.5864 52.3306H25.8608C26.23 52.3306 26.5244 52.2383 26.7441 52.0537C26.9668 51.8691 27.0781 51.6187 27.0781 51.3022C27.0781 50.9507 26.9756 50.6958 26.7705 50.5376C26.5654 50.3765 26.2534 50.2959 25.8345 50.2959H24.5864V52.3306ZM30.1938 53.4951V56H29.3501V49.6016H31.71C32.4102 49.6016 32.958 49.7803 33.3535 50.1377C33.752 50.4951 33.9512 50.9683 33.9512 51.5571C33.9512 52.1782 33.7563 52.6572 33.3667 52.9941C32.98 53.3281 32.4248 53.4951 31.7012 53.4951H30.1938ZM30.1938 52.8052H31.71C32.1611 52.8052 32.5068 52.6997 32.7471 52.4888C32.9873 52.2749 33.1074 51.9673 33.1074 51.5659C33.1074 51.1851 32.9873 50.8804 32.7471 50.6519C32.5068 50.4233 32.1772 50.3047 31.7583 50.2959H30.1938V52.8052ZM36.1177 49.6016L38.2095 54.8223L40.3013 49.6016H41.3955V56H40.5518V53.5083L40.6309 50.8188L38.5303 56H37.8843L35.7881 50.832L35.8716 53.5083V56H35.0278V49.6016H36.1177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrGreen);
export default __webpack_public_path__ + "static/media/HRGreen.cb5d89ca344c33adde53e898943573ec.svg";
export { ForwardRef as ReactComponent };